export default __webpack_public_path__ + "static/media/ic-menu.9cf2d484.svg";